import apiCallWrapper from '../../apiwrapper/apiCallWrapper';
import { getAllGitReports } from '../../store/slice/gitReportSlice';
import { invalidateSession } from '../../store/slice/sessionSlice';
import { store } from '../../store/store';
import { decrypt } from '../Helper/encryption';
import { IGitTrailResponse, IGitTrailResponseQueryFilters } from './gitTrail.interface';

const backEndServerUrl = String(process.env.REACT_APP_BACK_END_SERVER_URL ?? '');

export default class GitTrail {
  public subPath: string = '/trails/git';
  public reportSubPath: string = '/trails/git/report';
  public encryptedToken = sessionStorage.getItem('jwtToken');
  public jwtToken = decrypt(this.encryptedToken);
  public apiKey = String(process.env.REACT_APP_API_KEY ?? '');
  public config = {
    headers: {
      Authorization: this.jwtToken,
      'x-api-key': this.apiKey
    }
  };

  public async getGitLogs(query: string): Promise<IGitTrailResponse | null> {
    try {
      if (!query) {
        return null;
      }
      const axiosWithRoles = apiCallWrapper(this.subPath, 'GET');
      const url = this.createUrl(this.subPath);
      const response = await axiosWithRoles.get(url + `?${query}`);
      const data = response.data;
      return data ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public genrateQueryFromFilter(filter: IGitTrailResponseQueryFilters, next?: string): string {
    let query = `start=${filter.start}`;
    if (filter.end) {
      query += `&end=${filter.end}`;
    }
    if (filter.operation) {
      query += `&operation=${filter.operation}`;
    }
    if (filter.org) {
      query += `&org=${filter.org}`;
    }
    if (filter.email) {
      query += `&email=${filter.email}`;
    }
    if (next) {
      query += `&next=${next}`;
    }
    return query;
  }

  private validateFilters(filter: IGitTrailResponseQueryFilters): IGitTrailResponseQueryFilters {
    if (filter.start > Date.now()) {
      throw new Error('Invalid start date');
    }
    return {
      start: filter.start,
      end: filter.end ?? Date.now()
    };
  }

  public async getGitTrailReports(): Promise<any | null> {
    try {
      const axiosWithRoles = apiCallWrapper(this.reportSubPath, 'GET');
      const url = this.createUrl(this.reportSubPath);
      const response = await axiosWithRoles.get(url);
      const data = response.data;
      return data ?? null;
    } catch (error: any) {
      console.error(error);
      if (error.code === 'ERR_NETWORK') {
        store.dispatch(invalidateSession());
      }
      return null;
    }
  }

  public async getOneGitTrailReport(id: string): Promise<any | null> {
    try {
      const axiosWithRoles = apiCallWrapper(this.reportSubPath, 'GET');
      const url = this.createUrl(this.reportSubPath);
      const response = await axiosWithRoles.get(`${url}/${id}`);
      const data = response.data;
      return data ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  public async requestGitTrailReport(filter: IGitTrailResponseQueryFilters): Promise<string> {
    try {
      const filterObject = this.validateFilters(filter);
      const axiosWithRoles = apiCallWrapper(this.reportSubPath, 'GET');
      const url = this.createUrl(this.reportSubPath);
      const response = await axiosWithRoles.post(url, filterObject);
      const data = response.data;
      await store.dispatch(getAllGitReports());
      return 'Requested successfully';
    } catch (error) {
      console.error(error);
      return 'Something went wrong';
    }
  }

  private createUrl(params?: string): string {
    return backEndServerUrl + params;
  }
}
